import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

type InitialState = {
  meta: Record<string, any> | null;
  loading: boolean;
};
const initialState: InitialState = {
  meta: null,
  loading: true,
};

export const getMeta = createAsyncThunk(
  "meta/data",
  async (_, { getState }) => {
    const state: any = getState();
    if (state?.meta?.meta) {
      return state.meta.meta;
    }

    const res = await fetch(`${process.env.REACT_APP_BASE_URL}/meta`);
    const data = await res.json();
    return data;
  }
);

export const metaSlice = createSlice({
  name: "meta",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMeta.fulfilled, (state, action) => {
        state.meta = action.payload;
        state.loading = false;
      })
      .addCase(getMeta.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMeta.rejected, (state) => {
        state.loading = false; // Ensure loading is set to false on error.
      });
  },
});

export default metaSlice.reducer;
